// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.website-design-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 90px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  gap: 20px;
}

.website-design-image {
  position: relative;
  width: 35%;
  order: 1;
  margin-top: 50px;
}

.services-image {
  width: 100%;
  height: auto;
  border-radius: 8px;
  padding: 10px 0;
}

.website-design-text {
  width: 60%;
  order: 2;
  margin-top: -50px;
}

.website-design-text h1 {
  font-size: 2em;
  color: #000;
  margin-bottom: -5px;
}
.website-design-text h2 {
  font-size: 1rem;
  color: #555;
  margin-bottom: 10px;
}
.website-design-text p {
  font-size: 0rem;
  color: #555;
  margin-bottom: 20px;
}

.services-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  list-style: none;
  padding: 0;
}

.services-list li {
  width: 45%;
  font-size: 0.9em;
  color: #333;
}

.website-design-button {
  background-color: #00c853;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 1em;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
  transition: background-color 0.3s ease;
}

.website-design-button:hover {
  background-color: #009624;
}

@media (max-width: 768px) {
  .website-design-container {
    flex-direction: column;
    align-items: center;
    padding: 20px;
    gap: 10px;
  }

  .website-design-image {
    width: 88%;
    height: 20%;
    padding-top: 80px;
  }

  .website-design-text {
    width: 100%;
    text-align: left;
    margin-top: -10px;
    margin-bottom: 20px;
  }

  .website-design-text h1 {
    font-size: 2em;
  }

  .website-design-text h2 {
    font-size: 1em;
  }

  .website-design-text p {
    font-size: 0.9em;
  }

  .website-design-button {
    width: 100%;
  }
}

@media (min-width: 1380px) and (max-width: 1919px) {
  .website-design-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 80px;
    padding-top: 150px;
  }

  .website-design-image {
    width: 32%;
    margin-top: 20px;
  }

  .website-design-text {
    width: 62%;
    margin-top: -100px;
  }

  .website-design-text h1 {
    font-size: 2em;
  }

  .website-design-text h2 {
    font-size: 1rem;
  }

  .website-design-text p {
    font-size: 1rem;
  }

  .services-list li {
    width: 45%;
  }

  .website-design-button {
    font-size: 1em;
    padding: 10px 20px;
  }
}
@media (min-width: 1920px) {
  .website-design-container {
    max-width: 1600px;
    margin: 0 auto;
    padding: 100px;
  }

  .website-design-image {
    width: 40%;
    margin-top: 0;
  }

  .website-design-text {
    width: 55%;
    margin-top: 0;
  }

  .website-design-text h1 {
    font-size: 2.5em;
  }

  .website-design-text h2 {
    font-size: 1.2em;
  }

  .website-design-text p {
    font-size: 1.1rem;
  }

  .services-list li {
    width: 42%;
  }

  .website-design-button {
    font-size: 1.1em;
    padding: 15px 25px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/WebsiteDesign/WebsiteDesign.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,UAAU;IACV,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;AACF;AACA;EACE;IACE,iBAAiB;IACjB,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,UAAU;IACV,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF","sourcesContent":[".website-design-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 90px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  gap: 20px;\n}\n\n.website-design-image {\n  position: relative;\n  width: 35%;\n  order: 1;\n  margin-top: 50px;\n}\n\n.services-image {\n  width: 100%;\n  height: auto;\n  border-radius: 8px;\n  padding: 10px 0;\n}\n\n.website-design-text {\n  width: 60%;\n  order: 2;\n  margin-top: -50px;\n}\n\n.website-design-text h1 {\n  font-size: 2em;\n  color: #000;\n  margin-bottom: -5px;\n}\n.website-design-text h2 {\n  font-size: 1rem;\n  color: #555;\n  margin-bottom: 10px;\n}\n.website-design-text p {\n  font-size: 0rem;\n  color: #555;\n  margin-bottom: 20px;\n}\n\n.services-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  list-style: none;\n  padding: 0;\n}\n\n.services-list li {\n  width: 45%;\n  font-size: 0.9em;\n  color: #333;\n}\n\n.website-design-button {\n  background-color: #00c853;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 1em;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 20px;\n  transition: background-color 0.3s ease;\n}\n\n.website-design-button:hover {\n  background-color: #009624;\n}\n\n@media (max-width: 768px) {\n  .website-design-container {\n    flex-direction: column;\n    align-items: center;\n    padding: 20px;\n    gap: 10px;\n  }\n\n  .website-design-image {\n    width: 88%;\n    height: 20%;\n    padding-top: 80px;\n  }\n\n  .website-design-text {\n    width: 100%;\n    text-align: left;\n    margin-top: -10px;\n    margin-bottom: 20px;\n  }\n\n  .website-design-text h1 {\n    font-size: 2em;\n  }\n\n  .website-design-text h2 {\n    font-size: 1em;\n  }\n\n  .website-design-text p {\n    font-size: 0.9em;\n  }\n\n  .website-design-button {\n    width: 100%;\n  }\n}\n\n@media (min-width: 1380px) and (max-width: 1919px) {\n  .website-design-container {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding: 80px;\n    padding-top: 150px;\n  }\n\n  .website-design-image {\n    width: 32%;\n    margin-top: 20px;\n  }\n\n  .website-design-text {\n    width: 62%;\n    margin-top: -100px;\n  }\n\n  .website-design-text h1 {\n    font-size: 2em;\n  }\n\n  .website-design-text h2 {\n    font-size: 1rem;\n  }\n\n  .website-design-text p {\n    font-size: 1rem;\n  }\n\n  .services-list li {\n    width: 45%;\n  }\n\n  .website-design-button {\n    font-size: 1em;\n    padding: 10px 20px;\n  }\n}\n@media (min-width: 1920px) {\n  .website-design-container {\n    max-width: 1600px;\n    margin: 0 auto;\n    padding: 100px;\n  }\n\n  .website-design-image {\n    width: 40%;\n    margin-top: 0;\n  }\n\n  .website-design-text {\n    width: 55%;\n    margin-top: 0;\n  }\n\n  .website-design-text h1 {\n    font-size: 2.5em;\n  }\n\n  .website-design-text h2 {\n    font-size: 1.2em;\n  }\n\n  .website-design-text p {\n    font-size: 1.1rem;\n  }\n\n  .services-list li {\n    width: 42%;\n  }\n\n  .website-design-button {\n    font-size: 1.1em;\n    padding: 15px 25px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
